module.exports = __webpack_public_path__ + "img/monitor.ef285dc4.png";